import type {
  PhieuXuatDieuChuyenCellValue,
  PhieuXuatDieuChuyenChiTiet,
  PhieuXuatDieuChuyenDetailUpdate
} from '@/types/schemas';
import { roundNumber } from '@/lib/formatUtils';

const numericValue = (value: PhieuXuatDieuChuyenCellValue) =>
  typeof value === 'string' || typeof value === 'number' ? value : undefined;

export const handleUpdateRowFields = (
  row: PhieuXuatDieuChuyenChiTiet,
  field: string,
  newValue: PhieuXuatDieuChuyenCellValue
): PhieuXuatDieuChuyenDetailUpdate => {
  if (field === 'so_luong' || field === 'gia_nt') {
    const so_luong = roundNumber(field === 'so_luong' ? numericValue(newValue) : row.so_luong, 6);
    const gia_nt = roundNumber(field === 'gia_nt' ? numericValue(newValue) : row.gia_nt, 6);
    const tien_nt = roundNumber((Number(so_luong) || 0) * (Number(gia_nt) || 0), 6);

    return {
      tien_nt
    };
  }
  return {};
};

export function calculateTotals(detailItems: PhieuXuatDieuChuyenChiTiet[] = []) {
  const so_luong = roundNumber(
    detailItems.reduce((sum, item) => sum + (parseFloat(String(item.so_luong ?? '')) || 0), 0),
    6
  );
  const gia = roundNumber(
    detailItems.reduce((sum, item) => sum + (parseFloat(String(item.gia ?? '')) || 0), 0),
    6
  );
  const thanh_tien = roundNumber(
    detailItems.reduce((sum, item) => sum + (parseFloat(String(item.tien_nt ?? '')) || 0), 0),
    6
  );

  return {
    so_luong,
    gia,
    thanh_tien
  };
}
